import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.useFormatGlobalSearchDateLabel'

export default defineMessages({
  dateCreated: {
    id: `${scope}.dateCreated`,
    defaultMessage: 'Created {date}',
  },
  dateDue: {
    id: `${scope}.dateDue`,
    defaultMessage: 'Due {date}',
  },
  dateScheduled: {
    id: `${scope}.dateScheduled`,
    defaultMessage: 'Scheduled {date}',
  },
  dateEnds: {
    id: `${scope}.dateEnds`,
    defaultMessage: 'Ends {date}',
  },
})
